// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ChevronLeft = createIcon(
  <path
    clipRule="evenodd"
    d="M13.5397 7.61394C13.8912 7.96541 13.8912 8.53526 13.5397 8.88673L9.57968 12.8468L13.5397 16.8068C13.8912 17.1583 13.8912 17.7281 13.5397 18.0796C13.1882 18.4311 12.6184 18.4311 12.2669 18.0796L7.67049 13.4832C7.31902 13.1317 7.31902 12.5618 7.67049 12.2104L12.2669 7.61394C12.6184 7.26246 13.1882 7.26246 13.5397 7.61394Z"
    fillRule="evenodd"
  />,
);
